// Intercom customer support initialization
import config from '../config/config'

function initializeIntercom( appId: string ) {
	const w = window as any
	const ic = w.Intercom
	if ( typeof ic === 'function' ) {
		ic( 'reattach_activator' )
		ic( 'update', w.intercomSettings )
	} else {
		const d = document
		const i: any = function() {
			i.c( arguments )
		}
		i.q = []
		i.c = function( args: any ) {
			i.q.push( args )
		}
		w.Intercom = i
		const l = function() {
			const s = d.createElement( 'script' )
			s.type = 'text/javascript'
			s.async = true
			s.src = `https://widget.intercom.io/widget/${appId}`
			const x = d.getElementsByTagName( 'script' )[ 0 ]
			x.parentNode!.insertBefore( s, x )
		}
		if ( document.readyState === 'complete' ) {
			l()
		} else if ( w.attachEvent ) {
			w.attachEvent( 'onload', l )
		} else {
			w.addEventListener( 'load', l, false )
		}
	}
}

export function initializeIntercomSupport() {
	initializeIntercom( config.INTERCOM_APP_ID )
}
